import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import MasterDetailsReport from '../../../../common/components/MasterDetailsReport';
import Report from '../../../../common/components/Report';

const DespatchMonitoringReport = props => (
  <Report
    tabs={[
      {
        value: ReportDefinitions.DESPATCH_MONITORING_OVERVIEW.id,
        label: 'OVERVIEW',
      },
      {
        value: ReportDefinitions.DESPATCH_MONITORING_RESPONSE_PERFORMANCE.id,
        label: 'RESPONSE PERFORMANCE',
      },
      {
        value: ReportDefinitions.DESPATCH_MONITORING_RESPONSE_ANALYSIS.id,
        label: 'RESPONSE ANALYSIS',
      },
      {
        value: ReportDefinitions.DESPATCH_MONITORING_EVENT_TARGETS.id,
        label: 'EVENT TARGETS',
      },
      {
        value: ReportDefinitions.DESPATCH_MONITORING_RECEPTACLE_DETAILS.id,
        label: 'RECEPTACLE DETAILS',
      },
    ]
    }
    {...props}
  />
);
export default DespatchMonitoringReport;

DespatchMonitoringReport.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  masterDetailsReport: PropTypes.instanceOf(MasterDetailsReport),
  modeTabs: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string, label: PropTypes.string,
  })),
  mode: PropTypes.string,
  changeMode: PropTypes.func,
};
